import { FileIconComponent } from "../../../file-icon";
import styles from "./file.module.scss";

type Props = {
  name: string;
};
const FileIcon = ({ name }: Props) => (
  <div className={styles.icon}>
    <FileIconComponent filename={name} />
  </div>
);

export { FileIcon };
